import { guestConfirmedAt } from './visitIntent';

const LAST_SEEN_KEY = 'enterprise_salon_desk_last_guest_confirm';

export function markDeskGuestsSeen(checkins) {
  let max = '';
  for (const row of checkins || []) {
    const at = guestConfirmedAt(row);
    if (at && at > max) max = at;
  }
  if (max) {
    try {
      sessionStorage.setItem(LAST_SEEN_KEY, max);
    } catch {
      /* ignore */
    }
  }
}

export function hasNewGuestSinceLastSeen(checkins) {
  let max = '';
  for (const row of checkins || []) {
    const at = guestConfirmedAt(row);
    if (at && at > max) max = at;
  }
  if (!max) return false;
  let last = '';
  try {
    last = sessionStorage.getItem(LAST_SEEN_KEY) || '';
  } catch {
    /* ignore */
  }
  return max > last;
}

export function playDeskChime() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = 880;
    gain.gain.value = 0.08;
    osc.start();
    osc.stop(ctx.currentTime + 0.12);
    setTimeout(() => {
      const o2 = ctx.createOscillator();
      const g2 = ctx.createGain();
      o2.connect(g2);
      g2.connect(ctx.destination);
      o2.frequency.value = 1174;
      g2.gain.value = 0.08;
      o2.start();
      o2.stop(ctx.currentTime + 0.15);
    }, 140);
  } catch {
    /* ignore */
  }
}
